import { motion } from 'motion/react'
import { type FormSection } from '@/services/PriceCalculator/PriceCalculator.types'
import { useActiveFormSectionId } from '../../useActiveFormSectionId'
import { usePriceCalculatorForm } from '../../usePriceCalculatorForm'
import { usePriceCalculatorStep } from '../../usePriceCalculatorStep'
import { bar, progressBar } from './ProgressBar.css'

const getPriceCalculatorProgress = (step: string, activeSectionId: string, sections: Array<FormSection>) => {
  let progress = '0%'

  switch (step) {
    case 'viewOffers':
      return null
    case 'fillForm':
      switch (activeSectionId) {
        case 'ssn-se':
          // Don't show any progress in first section
          break
        default: {
          const activeSectionIndex = sections.findIndex((section) => section.id === activeSectionId)

          if (activeSectionIndex !== -1) {
            progress = `${(activeSectionIndex / sections.length) * 100}%`
          }
        }
      }
      break
    case 'calculatingPrice':
      progress = '100%'
      break
  }

  return progress
}

export function ProgressBar() {
  const { step } = usePriceCalculatorStep()
  const { activeFormSectionId } = useActiveFormSectionId()
  const form = usePriceCalculatorForm()

  const progress = getPriceCalculatorProgress(step, activeFormSectionId, form.sections)

  if (progress == null) return null

  return (
    <div className={bar}>
      <motion.div
        className={progressBar}
        style={{ originX: 0, scaleX: 0 }}
        animate={{ scaleX: progress }}
        transition={{ duration: 0.5 }}
      />
    </div>
  )
}
